import Loading from "../../../components/Common/Loading";

import {useGetArchivedStateV2MCQuery, useRestoreArchivedStateV2MCMutation} from "../../../core/api/mc-archive-api";
import {useParams} from "react-router-dom";
import Archive from "../../Archive/Archive";
import {useSelector} from "react-redux";
import {Alert} from "@mui/material";

function ArchiveMC(props) {
    const {deviceId, action, tab: tabParam, subtab: subTabParam, game} = useParams()

    const CommonData = useSelector((state) => state.data.CommonData)
    console.log("CommonData")
    console.log(CommonData)
    const stateId = CommonData.deviceId;

    const [restoreState, restoreStateResponse] = useRestoreArchivedStateV2MCMutation();
    const {
        data,
        isLoading,
        isSuccess,
        isError,
        error,
        refetch,
        isFetching
    } = useGetArchivedStateV2MCQuery(stateId);

    return (
        <>
            <h2>Archives for {stateId}</h2>
            {stateId=='' && <Alert severity={"info"}>Input vendor id</Alert> }
            {stateId!='' && <Loading
                isLoading={isLoading}
                isError={isError}
                error={error}
                isSuccess={isSuccess}
                isFetching={isFetching}
            >
                <Archive archiveListReady={isSuccess}
                         archiveList={data}
                         restoreState={restoreState}
                         restoreStateResponse={restoreStateResponse}
                         stateId={stateId}
                         refetch={refetch}
                         game={props.game}
                />
            </Loading>}

        </>
    );

}

export default ArchiveMC;
